// extracted by css-extract-rspack-plugin
export default {"cycleDetailItemContainer":"cycleDetailItemContainer-Yzl7fF","cycleDetailItemValue":"cycleDetailItemValue-AkIBFT","bookkeepingServiceItemList":"bookkeepingServiceItemList-KIupOJ"};